import type { ConceptCategory } from '@/db/Types'
import { Input } from '@/components/ui/Input'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/Select'
import { Button } from '@/components/ui/Button'
import './concept-header.css'

const CATEGORY_OPTIONS: { value: ConceptCategory; label: string }[] = [
	{ value: 'route', label: 'Route (Pass Concept)' },
	{ value: 'blocking', label: 'Run Scheme (Blocking)' },
	{ value: 'motion', label: 'Motion' },
	{ value: 'protection', label: 'Protection' },
]

interface ConceptHeaderProps {
	name: string
	onNameChange: (name: string) => void
	category: ConceptCategory
	onCategoryChange: (category: ConceptCategory) => void
	mode: 'visual' | 'ai'
	onModeChange: (mode: 'visual' | 'ai') => void
	onBackToPlaybook: () => void
}

export function ConceptHeader({
	name,
	onNameChange,
	category,
	onCategoryChange,
	mode,
	onModeChange,
	onBackToPlaybook,
}: ConceptHeaderProps) {
	return (
		<div className="concept-header">
			<div className="concept-header__content">
				<div className="concept-header__controls">
					<Input
						className="concept-header__name-input"
						placeholder="Concept name..."
						value={name}
						onChange={(e) => onNameChange(e.target.value)}
					/>
					<Select value={category} onValueChange={(v) => onCategoryChange(v as ConceptCategory)}>
						<SelectTrigger className="concept-header__category-select">
							<SelectValue />
						</SelectTrigger>
						<SelectContent>
							{CATEGORY_OPTIONS.map(opt => (
								<SelectItem key={opt.value} value={opt.value}>{opt.label}</SelectItem>
							))}
						</SelectContent>
					</Select>

					<div className="concept-header__mode-toggle">
						<button
							className="concept-header__mode-btn"
							data-active={mode === 'visual' || undefined}
							onClick={() => onModeChange('visual')}
							type="button"
						>
							Visual
						</button>
						<button
							className="concept-header__mode-btn"
							data-active={mode === 'ai' || undefined}
							onClick={() => onModeChange('ai')}
							type="button"
						>
							AI Assist
						</button>
					</div>
				</div>

				<div className="concept-header__button-area">
					<Button variant="action" className="concept-header__button" onClick={onBackToPlaybook}>
						Back to Playbook
					</Button>
				</div>
			</div>
		</div>
	)
}
